import "../../index26.css";
import { jsxs as v, jsx as r } from "react/jsx-runtime";
import { i as w } from "../../type-BFTbooL7.js";
import { _ as M } from "../../cs-piwRuCFZ.js";
import N from "../DefaultMessage/index.js";
import x from "../RawList/index.js";
import P from "../../hooks/useSpacingTokens.js";
const S = "_grid_1n8b5_1", j = "_message_1n8b5_10", k = "_compact_1n8b5_14", D = "_pending_1n8b5_17", E = "_two-columns_1n8b5_22", G = "_three-columns_1n8b5_31", L = "_four-columns_1n8b5_39", R = "_five-columns_1n8b5_43", e = {
  grid: S,
  message: j,
  compact: k,
  pending: D,
  twoColumns: E,
  threeColumns: G,
  fourColumns: L,
  fiveColumns: R
};
function I(m) {
  const {
    className: a,
    data: n,
    keySelector: i,
    renderer: c,
    rendererParams: l,
    numPreferredColumns: s,
    spacing: u = "default",
    pending: o,
    errored: p,
    filtered: g,
    errorMessage: _,
    emptyMessage: d,
    pendingMessage: f,
    filteredEmptyMessage: C,
    compact: t,
    withoutMessage: b
  } = m, h = w(n) || n.length === 0, y = P({ spacing: u });
  return /* @__PURE__ */ v(
    "div",
    {
      className: M(
        e.grid,
        s === 2 && e.twoColumns,
        s === 3 && e.threeColumns,
        s === 4 && e.fourColumns,
        s === 5 && e.fiveColumns,
        y,
        o && e.pending,
        t && e.compact,
        a
      ),
      children: [
        /* @__PURE__ */ r(
          x,
          {
            data: n,
            keySelector: i,
            renderer: c,
            rendererParams: l
          }
        ),
        !b && /* @__PURE__ */ r(
          N,
          {
            className: e.message,
            pending: o,
            filtered: g,
            empty: h,
            errored: p,
            compact: t,
            emptyMessage: d,
            filteredEmptyMessage: C,
            pendingMessage: f,
            errorMessage: _,
            overlayPending: !0
          }
        )
      ]
    }
  );
}
export {
  I as default
};
